import React from "react";
import { findAllCompetencyActivityPagedByCompetency } from "../../_services/competency_activity.service";
import { alertError } from "../../_utils/alerts";
import { getCompetencyId } from "../../_utils/storage_handler";

export const useCompetencyActivityByIdPaged = ({ page = 0, limit = 8 }) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllCompetencyActivityPagedByCompetency(getCompetencyId(), p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}